import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TicketReservationPlugin } from 'projects/qcloud-models/reservation-plugin/ticket-reservation-plugin';
import { ReservationQuestionType } from 'projects/qcloud-models/reservation/reservation-question-type.enum';
import { ReservationPluginService } from '../../services/reservation-plugin.service';
import { TicketReservationService } from '../../services/ticket-reservation.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { ReservationPluginInfo } from 'projects/qcloud-models/reservation-plugin/reservation-plugin-info';

@Component({
  selector: 'app-enea-confirmation-page',
  templateUrl: './enea-confirmation-page.component.html',
  styleUrls: ['./enea-confirmation-page.component.css']
})
export class EneaConfirmationPageComponent implements OnInit {

  @Input() ticketReservation: TicketReservationPlugin;
  @Input() reservationInfo: ReservationPluginInfo;
  categoryName: string;
  formSubmitted = false;
  displayReservationTime: Date;
  @Output() confirm = new EventEmitter<boolean>();

  constructor(public service: ReservationPluginService, private ticketReservationService: TicketReservationService,
    private recaptchaV3Service: ReCaptchaV3Service) {
  }

  ngOnInit(): void {
    this.displayReservationTime = new Date(this.ticketReservation.reservationTime.getFullYear(),
        this.ticketReservation.reservationTime.getMonth(),this.ticketReservation.reservationTime.getDate(),
        this.ticketReservation.reservationTime.getUTCHours(),this.ticketReservation.reservationTime.getMinutes());
    this.categoryName =
      this.ticketReservation.additionalReservationData.find(x => x.questionType == ReservationQuestionType.Case).answer;
  }

  submitReservation() {
    this.formSubmitted = true;
    if (this.reservationInfo.configuration.isRecaptcha) {
      this.recaptchaV3Service.execute('createReservation')
        .subscribe((token) => {
          this.makeReservation(token);
        });
    }
    else
    {
      this.makeReservation(null);
    }
  }

  makeReservation(token: string) {
    this.ticketReservation.sendMailOnReservation = this.reservationInfo.configuration.sendReservationEmail;
    this.ticketReservation.sendSmsOnReservation = this.reservationInfo.configuration.sendReservationSms;
    this.ticketReservation.captchaToken = token;
    this.service.createReservation(this.ticketReservation).subscribe(
      res => {
        this.formSubmitted = false;
        this.ticketReservation.code = res;
        this.ticketReservationService.updateTicketReservation(this.ticketReservation);
        this.ticketReservationService.toSummary();
      },
      err => {
        this.formSubmitted = false;
      }
    );
  }

  goBack() {
    this.ticketReservationService.toReservationDetails();
    this.confirm.emit(false);
  }

}
